export default __webpack_public_path__ + "static/media/2fa.cc315725.png";